import moment from "moment-timezone";
import { useState, useEffect } from "react";
import { TYPO } from "styles/Typo";
import ReletedStocks from "./ReletedStocks";
import Button from "components/common/buttons/buttons";
import DiscussSubscribeButton from "./Button/SubscribeButton";

function Agenda({
  detailDiscussData,
  isMobile,
  DebateAlarmOnStatus,
  debateAlarmRegister,
}: {
  detailDiscussData: any;
  isMobile: boolean;
  DebateAlarmOnStatus: any;
  debateAlarmRegister: any;
}) {
  const isClosed = detailDiscussData?.isClosed;
  const isEquallyVoted = detailDiscussData?.isEquallyVoted;

  return (
    <div className="pt-9 flex flex-col gap-6">
      <ReletedStocks data={detailDiscussData?.relatedStock} />

      <div className="px-6  flex flex-col gap-6">
        <h1
          className={`text-[28px] leading-[44.8px] font-[600] font-['Pretendard'] text-gray90  break-keep whitespace-pre-line  ${
            isMobile ? "max-w-[100%]" : ""
          } break-words`}
          data-testid="discuss-title"
        >
          {detailDiscussData?.title}
        </h1>
        <div className="flex items-center gap-[10px] ">
          <div className="flex items-center gap-1">
            <TimeIcon />

            <span className={`${TYPO.TYPO8_RG} text-gray80`}>
              {moment(detailDiscussData?.issue_at)
                .tz("Asia/Seoul")
                .format("YYYY.M.D")}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <EditIcon />

            <span className={`${TYPO.TYPO8_RG} text-gray80`}>
              리스크웨더 AI
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

const TimeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7.58073 6.76699V4.66699C7.58073 4.50171 7.52483 4.36317 7.41302 4.25137C7.30122 4.13956 7.16267 4.08366 6.9974 4.08366C6.83212 4.08366 6.69358 4.13956 6.58177 4.25137C6.46997 4.36317 6.41406 4.50171 6.41406 4.66699V6.98574C6.41406 7.06352 6.42865 7.13887 6.45781 7.21178C6.48698 7.2847 6.53073 7.35033 6.58906 7.40866L8.51406 9.33366C8.62101 9.4406 8.75712 9.49408 8.9224 9.49408C9.08767 9.49408 9.22379 9.4406 9.33073 9.33366C9.43767 9.22672 9.49115 9.0906 9.49115 8.92533C9.49115 8.76005 9.43767 8.62394 9.33073 8.51699L7.58073 6.76699ZM6.9974 12.8337C6.19045 12.8337 5.43212 12.6805 4.7224 12.3743C4.01267 12.068 3.39531 11.6524 2.87031 11.1274C2.34531 10.6024 1.92969 9.98505 1.62344 9.27533C1.31719 8.5656 1.16406 7.80727 1.16406 7.00033C1.16406 6.19338 1.31719 5.43505 1.62344 4.72533C1.92969 4.0156 2.34531 3.39824 2.87031 2.87324C3.39531 2.34824 4.01267 1.93262 4.7224 1.62637C5.43212 1.32012 6.19045 1.16699 6.9974 1.16699C7.80434 1.16699 8.56267 1.32012 9.2724 1.62637C9.98212 1.93262 10.5995 2.34824 11.1245 2.87324C11.6495 3.39824 12.0651 4.0156 12.3714 4.72533C12.6776 5.43505 12.8307 6.19338 12.8307 7.00033C12.8307 7.80727 12.6776 8.5656 12.3714 9.27533C12.0651 9.98505 11.6495 10.6024 11.1245 11.1274C10.5995 11.6524 9.98212 12.068 9.2724 12.3743C8.56267 12.6805 7.80434 12.8337 6.9974 12.8337Z"
        fill="var(--gray40)"
      />
    </svg>
  );
};

const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M2.44539 12.2345C2.24122 12.2831 2.06379 12.2321 1.9131 12.0814C1.7624 11.9307 1.71136 11.7533 1.75997 11.5491L2.27039 9.06992L4.92456 11.7241L2.44539 12.2345ZM5.87247 11.0095L2.98497 8.12201L9.00789 2.09909C9.2315 1.87548 9.50858 1.76367 9.83914 1.76367C10.1697 1.76367 10.4468 1.87548 10.6704 2.09909L11.8954 3.32409C12.119 3.5477 12.2308 3.82478 12.2308 4.15534C12.2308 4.48589 12.119 4.76298 11.8954 4.98659L5.87247 11.0095Z"
        fill="var(--gray40)"
      />
    </svg>
  );
};

{
  /** lagacy */
}
{
  /* <div
        className={
          isClosed
            ? `flex items-center justify-center bg-gray15 rounded-[15px] py-1 px-[10px]`
            : "hidden"
        }
      >
        <span
          className={`whitespace-pre-line text-center ${TYPO.TYPO7_MD} text-gray60`}
        >
          {isClosed
            ? detailDiscussData.userWon === null ||
              detailDiscussData.userWon === undefined
              ? "참여하지 않은 토론"
              : detailDiscussData.userWon
              ? isEquallyVoted
                ? "비긴 토론"
                : "내가 이긴 토론"
              : "내가 진 토론"
            : ""}
        </span>
      </div> */
}

{
  /* {isClosed
            ? detailDiscussData.userWon === null ||
              detailDiscussData.userWon === undefined
              ? isEquallyVoted
                ? "비긴 토론"
                : "참여하지 않은 토론"
              : detailDiscussData.userWon
              ? "내가 이긴 토론"
              : "내가 진 토론"
            : ""} */
}

export default Agenda;
